import {
    bl_fi_generic_doc_multi_session_RowClass
} from '../../dbschema/index';
import { BaseContainerModel } from '../base-container.model';

export class GenDocMultiSessionContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_multi_session: bl_fi_generic_doc_multi_session_RowClass = new bl_fi_generic_doc_multi_session_RowClass();
}
